export var EventDiceEnum = /*#__PURE__*/ function(EventDiceEnum) {
    EventDiceEnum[EventDiceEnum["Science"] = 4] = "Science";
    EventDiceEnum[EventDiceEnum["Trade"] = 5] = "Trade";
    EventDiceEnum[EventDiceEnum["Politics"] = 6] = "Politics";
    return EventDiceEnum;
}({});
